interface LoadingSpinnerProps {
  message?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const LoadingSpinner = ({
  message,
  size = "md",
  className = "",
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  };

  return (
    <div
      className={`flex items-center justify-center min-h-[400px] ${className}`}
    >
      <div className="text-center">
        <div
          className={`${sizeClasses[size]} mx-auto mb-4 border-4 border-global-primary border-t-transparent rounded-full animate-spin`}
        ></div>
        <p className="text-global-secondary text-size-sm">
          {message || "Cargando..."}
        </p>
      </div>
    </div>
  );
};
